import {
  applyPreprocessorBranch,
  preprocessCues,
  shouldSkipPreprocessForTrackType,
  type PreprocessFlags,
} from '@core/preprocess.ts';
import type { Cue } from '@core/model/cue.ts';
import type { RawTrackType } from '../state/subtitleStore.ts';

/** Apply preprocess flags to downloaded cues (mirrors extension SubtitlePipeline). */
export function preprocessTrackCues(
  cues: Cue[],
  flags: PreprocessFlags,
  trackType?: RawTrackType | string,
): Cue[] {
  // Extension SubtitlePipeline skips image tracks (B-PRE-04).
  if (shouldSkipPreprocessForTrackType(trackType)) return cues;
  return applyPreprocessorBranch(cues, flags, (raw) => preprocessCues(raw, flags)) as Cue[];
}
